import MuiThemeProvider from '@trinity/chat-components/components/Theme/MuiThemeProvider.js';
import { ChatWelcomeScreenContainer } from '@trinity/chat-components/containers/BrandInsights/ChatWelcomeScreen.Container.js';
import { QueryDownloaderContainer } from '@trinity/chat-components/containers/QueryDownloader/QueryDownloader.Container.js';
import FileUploadsProgressContainer from '@trinity/chat-components/containers/WorkspaceFileUpload/Upload.Progress.js';
import FileUploadsState from '@trinity/chat-components/containers/WorkspaceFileUpload/Upload.State.js';
import { AppReadyStateContainer } from '@/containers/AppReadyState';
import { AppStateEffectContainer } from '@/containers/AppStateEffect';
import { ChatCompatabilityProvider } from '@/containers/ChatCompatability/Chat.Compatability.Container';
import { AppThemingContainer } from '../AppTheming';
import { BrandInsightsContainer } from '../ChatCompatability/BrandInsights';
import { UserApplicationsContainer } from '../UserApplications/UserApplications';
import { UserBrandsContainer } from '../UserBrands/UserBrands';

export const AppSubscriber = (props: ChildrenProps) => {
  return (
    <AppReadyStateContainer>
      <UserBrandsContainer>
        <UserApplicationsContainer>
          <AppStateEffectContainer>
            <AppThemingContainer>
              <ChatCompatabilityProvider>
                <QueryDownloaderContainer>
                  <MuiThemeProvider>
                    <FileUploadsState>
                      <ChatWelcomeScreenContainer>
                        <BrandInsightsContainer>
                          <FileUploadsProgressContainer>
                            {props.children}
                          </FileUploadsProgressContainer>
                        </BrandInsightsContainer>
                      </ChatWelcomeScreenContainer>
                    </FileUploadsState>
                  </MuiThemeProvider>
                </QueryDownloaderContainer>
              </ChatCompatabilityProvider>
            </AppThemingContainer>
          </AppStateEffectContainer>
        </UserApplicationsContainer>
      </UserBrandsContainer>
    </AppReadyStateContainer>
  );
};
